module.exports = __webpack_public_path__ + "static/media/(TV) Verification Jul_Aug_2023.26dd728d.xlsx";